import React from 'react';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import ColumnSearchHeader from './ColumnSearchHeader';

const GridColumnHeader = ({ isDraggable, ...searchProps }) => (
  <div className="common-data-grid-column-header">
    {isDraggable && (
      <DragIndicatorIcon fontSize="small" className="common-data-grid-column-header__drag-icon" />
    )}
    <ColumnSearchHeader {...searchProps} />
  </div>
);

export default React.memo(GridColumnHeader);
